import React, { useState } from 'react';
import styled from 'styled-components';
import moment from 'moment';

import Radio from 'antd/es/radio';
import Form from 'antd/es/form';
import DatePicker from 'antd/es/date-picker';
import Checkbox from 'antd/es/checkbox/Checkbox';
import Button from 'antd/es/button';
import Divider from 'antd/es/divider';
import Tooltip from 'antd/es/tooltip';

import Icon from 'components/Icon';
import { Row, Col } from 'components/layout';
// import Select from 'components/Select';
import { datePickerFormats } from 'config/common';
import { disableDateRange } from '../helpers';

const CreateReportForm = ({
  form,
  reportTypeOptions = [],
  individualOptions = [],
  agencyOptions = [],
}) => {
  const [reportType, setReportType] = useState(() => {
    const option = reportTypeOptions.find(reportTypeOption => {
      return !reportTypeOption.disabled;
    });
    return option?.value || '';
  });

  const handleFromChange = (fromDate) => {
    const toDate = form.getFieldValue('to');
    if (toDate && fromDate) {
      const maxDate = moment(fromDate).add(31, 'days');
      if (toDate.isAfter(maxDate)) {
        form.setFieldsValue({ to: null });
      }
    }
  };

  const isWorkPrediction = reportType === 'WorkPrediction';

  return (
    <Form
      layout="vertical"
      form={form}
      onFinish={form.onSubmit}
      hideRequiredMark={true}
    >
      <FormGroup title="Report Type">
        <Form.Item
          initialValue={reportType}
          name="reportType"
          rules={[
            {
              required: true,
              message: 'Please select report type you want to generate',
            },
          ]}
        >
          <ReportTypeRadioGroup
            value={reportType}
            onChange={e => {
              setReportType(e.target.value);
            }}
          >
            {
              reportTypeOptions.map(reportTypeOption => (
                reportTypeOption.disabled ? <></>:
                <Radio key={reportTypeOption.value} value={reportTypeOption.value} disabled={reportTypeOption.disabled}>
                  { console.log(reportTypeOption.disabled)}
                  <span style={{ color: reportTypeOption.disabled ? 'rgba(0, 0, 0, 0.45)' : undefined }}>
                    {reportTypeOption.label}
                  </span>
                  <Icon name={reportTypeOption.icon} strokeWidth="1.5" color="#A4B0BA" size={36} />
                </Radio>
              ))
            }
          </ReportTypeRadioGroup>

        </Form.Item>
      </FormGroup>

      <Divider />

      <Row justify="center">
        <Col span={20}>
          {/* {reportType !== 'overall' && reportType !== 'Container' && reportType !== 'ShiftPerformance' && (
            <Row>
              <FormGroup title={`Select ${reportType.charAt(0).toUpperCase() + reportType.substr(1)}`}>
                <Row gutter={[24]}>
                  {reportType === 'individual' && (
                    <Col span={12}>
                      <Form.Item
                        label="Individual"
                        name="individualId"
                        rules={[
                          {
                            required: true,
                            message: 'Individual is required for this report'
                          }
                        ]}
                      >
                        <Select
                          options={individualOptions}
                          placeholder="Select individual"
                          showSearch={true}
                          optionFilterProp="children"
                        />
                      </Form.Item>
                    </Col>
                  )}
                  {reportType === 'agency' && (
                    <Col span={12}>
                      <Form.Item
                        label="Agency"
                        name="agencyId"
                        rules={[
                          {
                            required: true,
                            message: 'Agency is required for for this report'
                          }
                        ]}
                      >
                        <Select
                          options={agencyOptions}
                          placeholder="Select agency"
                          showSearch={true}
                          optionFilterProp="children"
                        />
                      </Form.Item>
                    </Col>
                  )}
                </Row>
              </FormGroup>
              <Divider />
            </Row>
          )} */}
          {!isWorkPrediction && (
            <Row>
              <FormGroup title="Time Period" tooltip="Time from start of the loading/unloading">
                <Tooltip 
                  title="Maximum date range is 31 days" 
                  placement="top"
                  trigger="hover"
                >
                  <Icon
                    name="info"
                    size={16}
                    color="#A4B0BA"
                    strokeWidth="2.5"
                    style={{
                      cursor: 'pointer',
                      marginLeft: 8
                    }}
                  />
                </Tooltip>
                <Row gutter={[24]}>
                  <Col span={12}>
                    <Form.Item
                      label="From"
                      name="from"
                      rules={[
                        {
                          required: true,
                          message: 'From date is required',
                        }
                      ]}
                    >
                      <DatePicker
                        placeholder="From date"
                        format={datePickerFormats.daily}
                        disabledDate={disableDateRange({ endDate: moment() })}
                        onChange={handleFromChange}
                        style={{
                          width: '100%',
                        }}
                      />
                    </Form.Item>
                  </Col>
                  <Col span={12}>
                    <Form.Item
                      dependencies={['from']}
                    >
                      {({ getFieldValue }) => {
                        const fromDate = getFieldValue('from');
                        return (
                        <Form.Item
                          label="To"
                          name="to"
                          rules={[
                            {
                              required: true,
                              message: 'To date is required',
                            }
                          ]}
                        >
                          <DatePicker
                            placeholder="To date"
                            format={datePickerFormats.daily}
                            disabledDate={(current) => {
                              if (!fromDate) return true;
                                const maxDate = moment(fromDate).add(30, 'days');
                                return (
                                  current && (current.isBefore(fromDate, 'day') || current.isAfter(maxDate, 'day') || disableDateRange({
                                      startDate: fromDate,
                                      endDate: moment(),
                                    })(current))
                                );
                              }}
                            style={{
                              width: '100%',
                            }}
                          />
                        </Form.Item>
                        );
                      }}
                    </Form.Item>
                  </Col>
                  <Col span={12}>
                    <Form.Item
                      initialValue={[1, 2]}
                      label="Shifts"
                      name="shifts"
                    >
                      <ShiftsCheckboxGroup
                        options={[
                          { label: 'First shift', value: 1 },
                          { label: 'Second shift', value: 2 },
                        ]}
                      />
                    </Form.Item>
                  </Col>
                </Row>
              </FormGroup>
            </Row>
          )}
        </Col>
      </Row>

      {!isWorkPrediction && <Divider />}

      <Row gutter={[24]} justify="end" style={{ paddingTop: '24px' }}>
        <Col>
          <Button
            type="primary"
            htmlType="submit"
            loading={form.isSubmitting}
            disabled={form.isSubmitting}
            style={{
              width: '200px',
            }}
          >
            Create report
          </Button>
        </Col>
      </Row>
    </Form>
  );
};

const FormGroup = styled.div`
  background: transparent;
  width: 100%;
  // border-bottom: 1px solid #E4E8ED;
  // padding-top: 24px;

  &:before {
    content: '${props => props.title}';
    color: #000000;
    font-weight: 600;
    font-size: 16px;
    line-height: 24px;
    display: inline-block;
    margin-bottom: 16px;
  }
`;

const ReportTypeRadioGroup = styled(Radio.Group)`
  display: flex;

  & .ant-radio-wrapper {
    display: flex;
    flex-direction: column-reverse;
    align-items: center;
    background: #FFFFFF;
    border: 1px solid #E4E8ED;
    padding: 12px 16px;
    border-radius: 8px;

    &:not(:last-child) {
      margin-right: 24px;
    }

    & > span:nth-of-type(2) {
      display: flex;
      flex-direction: column-reverse;
      align-items: center;
      width: 144px;
      padding-bottom: 12px;

      font-weight: normal;
      font-size: 14px;
      line-height: 20px;
      color: #232526;

      & > .anticon {
        display: inline-block;
        margin-bottom: 8px;
      }
    }
  }

  & .ant-radio-wrapper.ant-radio-wrapper-checked {
    background: #F5FDFF;
    border-color: #42B0D5;

    & > span:nth-of-type(2) {
      color: #42B0D5;

      & > .anticon svg {
        stroke: #42B0D5;
      }
    }
  }
`;

const ShiftsCheckboxGroup = styled(Checkbox.Group)`
  display: flex;
  flex-direction: column;

  & > .ant-checkbox-wrapper {
    margin-left: unset;

    &:not(:last-child) {
      margin-bottom: 8px;
    }
  }
`;

export default CreateReportForm;
